import { render, staticRenderFns } from "./PurchaseComplete.vue?vue&type=template&id=63348b43&scoped=true&"
import script from "./PurchaseComplete.vue?vue&type=script&lang=js&"
export * from "./PurchaseComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63348b43",
  null
  
)

export default component.exports